<template>
    <div class="flex items-center justify-center w-full">
        <div v-if="show && tooltip" class="flex relative w-[90%] rounded-lg mt-12 px-6 py-6 bg-[#ffffff] border-[1px] shadow-md border-gray-100 dark:bg-[#1b1c20] dark:border-[#232932]">
            <a @click.stop.prevent="close" class="inline-block absolute top-[-8px] left-[-8px] w-[62px] cursor-pointer">
                <span class="inline-flex justify-center items-center w-[26px] h-[26px] rounded-full bg-[#dedede] dark:bg-[#31313b] text-[#8a8993] dark:text-white">X</span>
            </a>
            <p class="dark:text-white text-black flex flex-row space-x-2 items-start">
                <span class="text-[#3f3c51] dark:text-gold"><InformationCircleIcon class="w-8 h-8 text-gold"/></span>
                <span>{{ tooltip }}</span>
            </p>
        </div>
    </div>
</template>

<script>
import {InformationCircleIcon} from "@heroicons/vue/solid";

export default {
    name: "TooltipComponent",
    components: {InformationCircleIcon},
    props: {
        tooltip: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    setup(props, {emit}) {
        const close = () => {
            emit("close")
        }

        return {
            close
        }
    }
}
</script>

<style scoped>

</style>
